import { useNavigation } from '@react-navigation/native';
import { VStack, Box, Text, Button, FlatList } from 'native-base';
import React, { useState } from 'react';
import {NativeStackNavigationProp} from "@react-navigation/native-stack";
import {RootStackParamList} from "../types";


interface DetalhesContaScreenProps {
    onSignOut: () => void;
}


const DetalhesContaScreen: React.FC<DetalhesContaScreenProps> = ({ onSignOut }) => {


    const navigation = useNavigation();
    const [transactions, setTransactions] = useState<
        Array<{ id: string; description: string; amount: number }>
    >([
        { id: "1", description: "CRÉDITO CONTA CLIENTE", amount: 1500 },
        { id: "2", description: "TRANSFERÊNCIA MOTORISTA CÓD 56748", amount: -200 },
        { id: "3", description: "TRANSFERÊNCIA MOTORISTA CÓD 57890", amount: -300 },
    ]);


    return (
        <VStack flex={1} bg="gray.100" alignItems="left" justifyContent="space-between" p={5}>
            <Box p={4} m={2} bg="white" rounded="lg" shadow={1} flex={1} justifyContent={'left'}>
                <Text fontSize="lg" color={'#384085'} bold mb={2}>
                Movimento da Conta
                </Text>

                <Text fontSize="14px" fontWeight={'700'} color={'#384085'} bold mb={2}>
                26/11/2024
                </Text>
                <FlatList
                data={transactions}
                keyExtractor={(item) => item.id}
                renderItem={({ item }) => (
                    <Box p={2} borderBottomWidth={1} borderColor="gray.200">
                    <Text fontSize="sm">{item.description}</Text>
                    <Text
                        fontSize="md"
                        bold
                        color={item.amount < 0 ? "red.500" : "green.500"}
                    >
                        R$ {item.amount.toLocaleString()}
                    </Text>
                    </Box>
                )}
                />

                <Text fontSize="14px" fontWeight={'700'} color={'#384085'} bold mb={2}>
                26/11/2024
                </Text>
                <FlatList
                data={transactions}
                keyExtractor={(item) => item.id}
                renderItem={({ item }) => (
                    <Box p={2} borderBottomWidth={1} borderColor="gray.200">
                    <Text fontSize="sm">{item.description}</Text>
                    <Text
                        fontSize="md"
                        bold
                        color={item.amount < 0 ? "red.500" : "green.500"}
                    >
                        R$ {item.amount.toLocaleString()}
                    </Text>
                    </Box>
                )}
                />
            </Box>
            <Box>
                <Button colorScheme="lightBlue" fontSize={'18px'} onPress={() => navigation.navigate("Home")}>
                    Voltar
                </Button>
            </Box>
        </VStack>
    );
};

export default DetalhesContaScreen;
